import { render, staticRenderFns } from "./PictureSlide.vue?vue&type=template&id=3853ddfe&scoped=true&"
import script from "./PictureSlide.vue?vue&type=script&lang=js&"
export * from "./PictureSlide.vue?vue&type=script&lang=js&"
import style0 from "./PictureSlide.vue?vue&type=style&index=0&id=3853ddfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3853ddfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
